import React from 'react';

export function HowItWorks() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block bg-orange-100 border border-orange-200 rounded-full px-6 py-2 mb-6">
            <span className="text-orange-700 font-semibold text-sm">🚀 HOW IT WILL WORK</span>
          </div>
          <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-6">
            How it works
          </h2>
          <p className="text-2xl text-gray-600 max-w-4xl mx-auto font-light">
            When we launch, you'll get from "my app is built" to "my app is growing" in three simple steps
          </p>
        </div>
        
        <div className="relative">
          {/* Progress line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-orange-200 via-orange-300 to-orange-400 transform -translate-y-1/2 z-0"></div>
          
          <div className="grid lg:grid-cols-3 gap-12 lg:gap-8 relative z-10">
            {/* Step 1 */}
            <div className="group">
              <div className="bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 relative overflow-hidden">
                {/* Background decoration */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-orange-100 to-transparent rounded-bl-full opacity-50"></div>
                
                <div className="relative z-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-600 to-orange-700 rounded-2xl flex items-center justify-center mb-8 mx-auto shadow-lg">
                    <span className="text-3xl font-bold text-white">1</span>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                    Connect your GitHub repo
                  </h3>
                  <p className="text-lg text-gray-600 text-center leading-relaxed font-light">
                    Connect your GitHub repository with one click. Works with any repo from Lovable, Cursor, v0, Bolt, or any AI coding tool.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Step 2 */}
            <div className="group">
              <div className="bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 relative overflow-hidden">
                {/* Background decoration */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-orange-100 to-transparent rounded-bl-full opacity-50"></div>
                
                <div className="relative z-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-600 to-orange-700 rounded-2xl flex items-center justify-center mb-8 mx-auto shadow-lg">
                    <span className="text-3xl font-bold text-white">2</span>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                    Get your audit report
                  </h3>
                  <p className="text-lg text-gray-600 text-center leading-relaxed font-light">
                    Automated analysis in 2 minutes. See exactly what's missing: analytics tracking, customer support setup, email capture, marketing pixels, and conversion tracking.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Step 3 */}
            <div className="group">
              <div className="bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 relative overflow-hidden">
                {/* Background decoration */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-orange-100 to-transparent rounded-bl-full opacity-50"></div>
                
                <div className="relative z-10">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-600 to-orange-700 rounded-2xl flex items-center justify-center mb-8 mx-auto shadow-lg">
                    <span className="text-3xl font-bold text-white">3</span>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                    Fix the issues
                  </h3>
                  <p className="text-lg text-gray-600 text-center leading-relaxed font-light">
                    Follow detailed implementation steps included in your report. Prioritized recommendations with code examples.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-20">
          <p className="text-xl text-gray-600 mb-8 font-light">
            Join the waitlist to be notified when our automated audit tool is ready.
          </p>
          <button className="bg-gradient-to-r from-orange-600 to-orange-700 text-white font-bold text-xl px-12 py-4 rounded-full hover:from-orange-700 hover:to-orange-800 transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer">
            Join Waitlist - Early Bird $19
          </button>
        </div>
      </div>
    </section>
  );
}